import * as React from "react";
const SvgIntersectingBubbleChart = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("circle", {
	opacity: .7,
	cx: 16.0022,
	cy: 22.0005,
	r: 7.75024,
	stroke: "currentColor",
	strokeWidth: 2.5
}), /* @__PURE__ */ React.createElement("circle", {
	opacity: .7,
	cx: 10.0002,
	cy: 10.0002,
	r: 7.75024,
	stroke: "currentColor",
	strokeWidth: 2.5
}), /* @__PURE__ */ React.createElement("circle", {
	opacity: .7,
	cx: 22.0002,
	cy: 10.0002,
	r: 7.75024,
	stroke: "currentColor",
	strokeWidth: 2.5
}));
export default SvgIntersectingBubbleChart;
